export var RULE_TYPE = 'RULE';
export var KEYFRAME_TYPE = 'KEYFRAME';
export var FONT_TYPE = 'FONT';
export var STATIC_TYPE = 'STATIC';
export var CLEAR_TYPE = 'CLEAR';